export function isNumberNorwegianMobile(phone: string): boolean {
  const cleaned: string = phone.replace(/[\s\-+]/g, '');
  const norwegianRegex = /^(0047|47)?([49]\d{7})$/;
  return norwegianRegex.test(cleaned);
}
